import type { LongCopy } from '../copy'

export const th: LongCopy = {
  home: { title: 'ดาว ABV Develop', lead: 'ที่นี่คือบ้านของทีมและความเชี่ยวชาญของเรา รอบ ๆ มีดวงจันทร์ของแต่ละทีมโคจรอยู่ ไกลออกไปคือดาวของโปรเจกต์ที่เราสร้าง เลือกจุดหมายได้เลย', cta: 'ส่งภารกิจการบิน' },
  team: {
    analytics: {
      name: 'การวิเคราะห์ระบบ',
      tagline: 'แปลธุรกิจให้เป็นภาษาของระบบ',
      about: 'ทุกโปรเจกต์เริ่มต้นที่นี่ นักวิเคราะห์ของเราทำความเข้าใจว่าธุรกิจของลูกค้าทำงานจริงอย่างไร แล้วแปลงเป็นความต้องการ แผนผังกระบวนการ และสัญญา API เพื่อให้ทีมพัฒนาได้โดยไม่ต้องเดา',
      facts: ['เข้าใจกระบวนการก่อน แล้วค่อยเขียนโค้ด', 'ความต้องการ แผนผังกระบวนการ และต้นแบบหน้าจอ', 'ตกลงสัญญา API ก่อนเริ่มพัฒนา'],
      soon: 'ข่าวและการค้นพบจากทีมวิเคราะห์กำลังจะมาเร็ว ๆ นี้',
    },
    ai: {
      name: 'วิศวกรรม AI',
      tagline: 'ใส่ความฉลาดเข้าไปในงานจริง',
      about: 'ทีมออกแบบ AI เอเจนต์ ระบบค้นหาข้อมูลของบริษัท การอ่านเอกสาร และการเชื่อมต่อผู้ช่วย AI ผ่านมาตรฐาน MCP เพื่อให้ AI ทำงานให้กระบวนการจริง ไม่ใช่แค่เดโม',
      facts: ['AI เอเจนต์และเซิร์ฟเวอร์ MCP', 'การค้นหาและ RAG บนข้อมูลของบริษัท', 'การอ่านเอกสาร ไฟล์สแกน และสเปก'],
      soon: 'การทดลองและข่าวจากทีม AI กำลังจะมาเร็ว ๆ นี้',
    },
    development: {
      name: 'การพัฒนา',
      tagline: 'สร้างระบบที่ใช้งานได้ยาวนานหลายปี',
      about: 'นักพัฒนา backend และ frontend ทำงานตามสัญญาที่ตกลงกันไว้ มีการรีวิวโค้ด ควบคุมเวอร์ชัน และสถาปัตยกรรมที่รองรับการเติบโตทั้งโหลดและฟีเจอร์ใหม่',
      facts: ['backend และ frontend อยู่ในทีมเดียวกัน', 'รีวิวโค้ดทุกครั้ง', 'สถาปัตยกรรมสำหรับโหลดสูง'],
      soon: 'ข่าวและไฮไลต์เทคโนโลยีจากนักพัฒนากำลังจะมาเร็ว ๆ นี้',
    },
    testing: {
      name: 'การทดสอบ',
      tagline: 'เจอข้อผิดพลาดก่อนที่ลูกค้าจะเจอ',
      about: 'วิศวกร QA ทดสอบฟังก์ชัน การเชื่อมต่อ และการถดถอย ทำเทสต์อัตโนมัติสำหรับสถานการณ์สำคัญ และทดสอบโหลดก่อนขึ้นระบบจริงทุกครั้ง',
      facts: ['ทดสอบฟังก์ชัน การเชื่อมต่อ และการถดถอย', 'เทสต์อัตโนมัติสำหรับขั้นตอนสำคัญ', 'ทดสอบโหลดก่อนเปิดใช้งาน'],
      soon: 'ข่าวและชาเลนจ์จากทีม QA กำลังจะมาเร็ว ๆ นี้',
    },
    devops: {
      name: 'DevOps',
      tagline: 'ปล่อยงานได้เร็วและเสถียร',
      about: 'บิลด์และดีพลอยอัตโนมัติไปยังสภาพแวดล้อมทดสอบและใช้งานจริง มอนิเตอร์ ความปลอดภัย และการขยายระบบ เพื่อให้เวอร์ชันใหม่ออกได้บ่อยและไม่มีเรื่องเซอร์ไพรส์',
      facts: ['CI/CD ครบทุกสภาพแวดล้อม', 'มอนิเตอร์และติดตามข้อผิดพลาด', 'คลัสเตอร์และกระจายโหลด'],
      soon: 'ข่าวและเคล็ดลับจากทีม DevOps กำลังจะมาเร็ว ๆ นี้',
    },
  },
  projects: { platform: 'แพลตฟอร์มดิสทริบิวชัน', grid: 'โครงข่ายไฟฟ้าดิจิทัล', panel: 'สถานีไฟฟ้าใน 10 นาที' },
  careers: { name: 'อวกาศเปิด', lead: 'ดาวสำหรับทุกคนที่อยากสร้างระบบไปด้วยกันกับเรา ทุกตำแหน่งงานคือภารกิจหนึ่งภารกิจ', mission: 'รับภารกิจ →' },
  mission: {
    title: 'ภารกิจ «จากไอเดียสู่การปล่อยงาน»',
    intro: 'เดินตามเส้นทางเดียวกับทุกโปรเจกต์ของเรา: วิเคราะห์ → AI → พัฒนา → ทดสอบ → ปล่อยงาน ปลายทางมีโปสการ์ดพร้อมคำอวยพรให้ดาวน์โหลด',
    progress: 'ขั้นตอนของภารกิจ',
    locked: 'ขั้นตอนนี้จะเปิดหลังจากดาว',
    goTo: 'บินไปที่นั่น',
    done: 'ผ่านขั้นตอนแล้ว!',
    continueTo: 'ขั้นตอนถัดไป:',
    analytics: {
      task: 'งานของนักวิเคราะห์: เลือก 3 การ์ด — โปสการ์ดควรให้ความรู้สึกแบบไหน?',
      cards: [
        { id: 'calm', label: 'สงบ' }, { id: 'energy', label: 'พลัง' }, { id: 'luck', label: 'โชคดี' },
        { id: 'team', label: 'สำหรับทีม' }, { id: 'bold', label: 'ไอเดียกล้า' }, { id: 'joy', label: 'ความสุข' },
      ],
      pick: 'เลือกแล้ว',
      confirm: 'อนุมัติความต้องการ',
    },
    ai: {
      task: 'AI เขียนคำอวยพรจากความต้องการของคุณแล้ว เลือกข้อความที่ดีที่สุด',
      generating: 'โมเดลกำลังคิด…',
      choose: 'เลือก',
      wishes: {
        calm: ['ขอให้วันนี้สงบ และทุกงานแก้ได้ง่าย'],
        energy: ['พลังเต็มเปี่ยมทั้งวัน แถมเหลือไว้ตอนเย็นอีกนิด!'],
        luck: ['ขอให้วันนี้ทุกอย่างสำเร็จตั้งแต่ครั้งแรก'],
        team: ['ขอให้คุณและทีมมีวันที่ยอดเยี่ยม!'],
        bold: ['ขอให้ไอเดียกล้า ๆ วันนี้กลายเป็นแผนจริง'],
        joy: ['มีเรื่องให้ยิ้มมากขึ้น เริ่มตั้งแต่วันนี้!'],
      },
      fallback: ['ขอให้เป็นวันที่ดี และงานง่ายทุกชิ้น!'],
    },
    development: {
      task: 'ประกอบโปสการ์ดจากชิ้นส่วนสำเร็จรูป',
      backgrounds: ['อวกาศลึก', 'แสงเหนือ', 'พระอาทิตย์ตกในวงโคจร'],
      planets: ['ดาว ABV', 'ดาวยักษ์มีวงแหวน', 'ดวงจันทร์สีฟ้า'],
      bg: 'พื้นหลัง',
      planet: 'ดาว',
      build: 'เริ่มบิลด์',
    },
    testing: {
      task: 'หาบั๊ก 3 จุดในบิลด์ — แตะที่โปสการ์ดได้เลย',
      found: 'พบแล้ว',
      bugs: ['คำพิมพ์ผิดในข้อความ', 'ดาวที่วางผิดตำแหน่ง', 'ดาวสีแดงที่เกินมา'],
      allFound: 'แก้บั๊กครบแล้ว — บิลด์พร้อมปล่อย',
    },
    devops: {
      task: 'ทดสอบครบแล้ว ปล่อยงานกันเลย!',
      countdown: 'นับถอยหลัง',
      launch: 'ปล่อยเวอร์ชัน',
      released: 'ปล่อยงานสำเร็จ!',
    },
    postcard: {
      title: 'โปสการ์ดของคุณพร้อมแล้ว',
      nameLabel: 'ส่งให้ใคร',
      namePlaceholder: 'ชื่อ',
      from: 'ด้วยความปรารถนาดีจากระบบ ABV Develop',
      download: 'ดาวน์โหลดโปสการ์ด',
      share: 'คัดลอกลิงก์เว็บไซต์',
      copied: 'คัดลอกลิงก์แล้ว',
      again: 'เล่นอีกครั้ง',
      greeting: 'ขอให้เป็นวันที่ดี',
    },
  },
  brief: {
    title: 'ภารกิจการบิน',
    intro: 'เล่าโจทย์ของคุณใน 4 ขั้นตอน — คำขอจะบินไปถึงทีมของเรา แล้วเราจะติดต่อกลับ',
    steps: ['จุดหมาย', 'สัมภาระ', 'ระยะเวลา', 'ลูกเรือ'],
    destination: 'คุณต้องการระบบแบบไหน?',
    destinations: [
      { id: 'erp', label: 'ERP / CRM', hint: 'กระบวนการ บัญชี เอกสาร' },
      { id: 'catalog', label: 'แคตตาล็อกและการค้นหา', hint: 'พอร์ทัล B2B สินค้าจำนวนมาก' },
      { id: 'ai', label: 'AI เอเจนต์', hint: 'ระบบอัตโนมัติ MCP การอ่านเอกสาร' },
      { id: 'engineering', label: 'ระบบวิศวกรรม', hint: 'พลังงาน คอนฟิกูเรเตอร์ GIS' },
      { id: 'other', label: 'อื่น ๆ', hint: 'มาหาคำตอบด้วยกัน' },
    ],
    cargo: 'อะไรสำคัญในโปรเจกต์นี้? เลือกได้หลายข้อ',
    cargoItems: ['ทำกระบวนการให้อัตโนมัติ', 'เชื่อมต่อกับระบบอื่น', 'รองรับโหลดสูง', 'AI และข้อมูล', 'พัฒนาระบบเดิมต่อ', 'เริ่มจากศูนย์'],
    cargoNote: 'เล่าโจทย์สั้น ๆ (ไม่บังคับ)',
    timeline: 'อยากเริ่มเมื่อไร?',
    timelines: ['เร็วที่สุด', 'ภายใน 1–3 เดือน', 'ประมาณครึ่งปี', 'ยังศึกษาอยู่'],
    crew: 'ให้เราติดต่อใคร?',
    name: 'ชื่อ',
    email: 'อีเมลที่ทำงาน',
    message: 'ความคิดเห็น',
    next: 'ถัดไป',
    back: 'ย้อนกลับ',
    launch: 'ส่งคำขอ',
    sending: 'กำลังส่ง…',
    sent: 'คำขอของคุณเข้าสู่วงโคจรแล้ว! เราจะตอบกลับทางอีเมลโดยเร็ว',
    error: 'ส่งไม่สำเร็จ ลองอีกครั้ง หรือเขียนถึง sales@abvdevelop.com',
    summary: 'ภารกิจการบินจากเว็บไซต์',
  },
}
